













import { Component, Vue } from "vue-property-decorator";
@Component
export default class AuthResponse extends Vue {
    error = "" as string;
    errorDescription = "" as string;

    async mounted() {
        // available query string parameters
        // const code = this.$route.query.code ? this.$route.query.code.toString() : "";
        // const state = this.$route.query.state ? this.$route.query.state.toString() : "";
        // const adminConsent = this.$route.query.admin_consent ? this.$route.query.admin_consent.toString() : "";
        // const authorizationId = this.$route.query.authorizationId ? this.$route.query.authorizationId.toString() : "";

        window.localStorage.setItem("refresh", "true");

        this.error = this.$route.query.error ? this.$route.query.error.toString() : "";
        this.errorDescription = this.$route.query.error_description ? this.$route.query.error_description.toString() : "";
    }

    beforeUnmount() {
        this.error = "" as string;
        this.errorDescription = "" as string;
    }
}
